import { useTranslate } from "@growtherapy/i18n";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "@growtherapy/sprout-ui";

export function TakeOverScreenShareModal({
  isModalOpen,
  onCloseModal,
  onConfirmShare,
}: {
  isModalOpen: boolean;
  onCloseModal: () => void;
  onConfirmShare: () => void;
}) {
  const t = useTranslate();
  return (
    <Modal
      isOpen={isModalOpen}
      onClose={onCloseModal}
      onOutsideClick={onCloseModal}
    >
      <ModalHeader>
        {t("telehealth-core:screenShare.stopOthersScreenShare")}
      </ModalHeader>
      <ModalBody>
        {t(
          "telehealth-core:screenShare.sharingYourScreenWillStopTheOtherPersonsScreenShare",
        )}
      </ModalBody>
      <ModalFooter
        actions={[
          {
            key: "cancel",
            use: "secondary",
            onClick: onCloseModal,
            actionContent: t("telehealth-core:screenShare.cancel"),
          },
          {
            key: "confirm",
            use: "primary",
            onClick: onConfirmShare,
            actionContent: t("telehealth-core:screenShare.yesShareMyScreen"),
          },
        ]}
      />
    </Modal>
  );
}
